<template>
    <div>
        <div>
            <vx-card>
                <img class="" v-bind:src="logoUrl" alt="algolia-logo" />
                <div>
                    <div>
                        <p>Teslimat ve İade Bildirimi&nbsp;</p>
                    </div>
                    <div>
                        <p> &nbsp;</p>
                    </div>
                    <div>
                        <p>1) TESLİMAT S&Uuml;RESİ: &nbsp;</p>
                    </div>
                    <div>
                        <p>murattekstil.com.tr, satın alınan her bir &uuml;r&uuml;n&uuml; 30 g&uuml;n&uuml; aşmamak kaydı
                            ile
                            alıcının g&ouml;stermiş olduğu adres kişi ve/veya kuruluşa teslim
                            etmekle&nbsp;y&uuml;k&uuml;ml&uuml;d&uuml;r.Bu&nbsp;s&uuml;re i&ccedil;inde &uuml;r&uuml;n
                            teslim
                            edilmez ise alıcı s&ouml;zleşmeyi iptal&nbsp;edebilir.Teslimat&nbsp;s&uuml;resi satın alınan
                            &uuml;r&uuml;n&uuml;n mevcut stok&nbsp;durumuna ,&uuml;retim&nbsp;s&uuml;resine g&ouml;re
                            değişiklik&nbsp;g&ouml;sterebilir.Sipariş&nbsp;kargoya verildikten sonra alıcı&nbsp;e-posta
                            yoluyla
                            bilgilendirilir.&nbsp;</p>
                    </div>
                    <div>
                        <p>&nbsp;</p>
                    </div>
                    <div>
                        <p>2) TESLİMAT ŞEKLİ: &nbsp;</p>
                    </div>
                    <div>
                        <p>Satın alınan &uuml;r&uuml;n dugmebul.com sitesinin &ouml;n bilgilendirme ve mesafeli satış
                            s&ouml;zleşmesinde beyan etmiş olduğu kargo firması ile d&uuml;zg&uuml;n ve paketlenmiş bir
                            şekilde
                            alıcıya teslim edilir.&nbsp;</p>
                    </div>
                    <div>
                        <p>&nbsp;</p>
                    </div>
                    <div>
                        <p>3) KARGO &Uuml;CRETİ: &nbsp;</p>
                    </div>
                    <div>
                        <p>murattekstil.com.tr&nbsp;sitesi &uuml;zerinde herhangi bir
                            kampanya&nbsp;yada&nbsp;promosyon&nbsp;bildirisinde bulunulmadığı s&uuml;rece kargo &uuml;creti
                            alıcıya aittir.&nbsp;</p>
                    </div>
                    <div>
                        <p>&nbsp;</p>
                    </div>
                    <div>
                        <p>4) TESLİM ALMA:&nbsp;</p>
                    </div>
                    <div>
                        <p>Alıcı adreste bulunamadığı takdirde kargo firması bir bilgi notu&nbsp;bırakır.Takip&nbsp;eden 3
                            iş
                            g&uuml;n&uuml; kargo adresin bulunduğu ilgili kargo şubesinde&nbsp;bekletilir.Alıcı&nbsp;kargoyu
                            almadığı takdirde kargo firmamıza geri iade&nbsp;edilir.Alıcı&nbsp;kargoyu teslim alırken
                            pakette
                            herhangi bir hasar olup olmadığını kontrol&nbsp;etmelidir.Eğer&nbsp;bir hasar var ise kargo
                            g&ouml;revlisine tutanak&nbsp;tutturmalıdır.Adreste&nbsp;alıcı dışında
                            &uuml;&ccedil;&uuml;nc&uuml;
                            bir kişi var ise kimlik ibrazı ile paket bu kişiye teslim edilebilir.&nbsp;</p>
                    </div>
                    <div>
                        <p>&nbsp;</p>
                    </div>
                    <div>
                        <p>4) İADE&nbsp;HAKKI :&nbsp;</p>
                    </div>
                    <div>
                        <p>6502 sayılı T&uuml;keticinin Korunması Hakkında Kanun ve Mesafeli S&ouml;zleşmeler
                            Y&ouml;netmeliği
                            ilgili h&uuml;k&uuml;mleri gereğince;&nbsp;</p>
                    </div>
                    <div>
                        <p>T&uuml;ketici; 14 (on d&ouml;rt) g&uuml;n i&ccedil;inde herhangi bir gerek&ccedil;e
                            g&ouml;stermeksizin ve cezai şart &ouml;demeksizin S&ouml;zleşmeden cayma hakkına sahiptir.
                            Cayma
                            hakkı s&uuml;resi, hizmet ifasına ilişkin s&ouml;zleşmelerde s&ouml;zleşmenin kurulduğu
                            g&uuml;n;
                            mal teslimine ilişkin s&ouml;zleşmelerde t&uuml;ketici yahut t&uuml;ketici tarafından belirlenen
                            &uuml;&ccedil;&uuml;nc&uuml; kişinin malı teslim ettiği g&uuml;n başlar. Ancak T&uuml;ketici,
                            S&ouml;zleşmenin kurulmasından malın teslimine kadar olan s&uuml;re&ccedil;te de cayma hakkını
                            kullanabilir.&nbsp;</p>
                    </div>
                    <div>
                        <p> &nbsp;</p>
                    </div>
                    <div>
                        <p>Cayma hakkının kullanıldığına dair bildirimin bu s&uuml;re i&ccedil;inde yazılı olarak veya
                            kalıcı
                            veri saklayıcısı ile Şirket&rsquo;e y&ouml;neltilmiş olması yeterlidir.&nbsp;</p>
                    </div>
                    <div>
                        <p> &nbsp;</p>
                    </div>
                    <div>
                        <p>Şirket malı kendisinin geri alacağına dair bir teklifte bulunmadık&ccedil;a, T&uuml;ketici cayma
                            hakkını kullandığına ilişkin bildirimi y&ouml;nelttiği tarihten itibaren 10 (on) g&uuml;n
                            i&ccedil;inde malı Şirket veya yetkilendirmiş olduğu kişiye geri g&ouml;ndermek zorundadır. Aksi
                            halde T&uuml;ketici cayma hakkından feragat etmiş olur.&nbsp;</p>
                    </div>
                    <div>
                        <p> &nbsp;</p>
                    </div>
                    <div>
                        <p>T&uuml;ketici&rsquo;nin&nbsp;cayma hakkı (i)&nbsp;T&uuml;ketici&rsquo;nin&nbsp;istekleri veya
                            kişisel
                            ihtiya&ccedil;ları doğrultusunda hazırlanan mallara, (ii) &ccedil;abuk bozulabilen veya son
                            kullanma
                            tarihi ge&ccedil;ebilecek malların teslimine, (iii) tesliminden sonra ambalaj, bant,
                            m&uuml;h&uuml;r, paket gibi koruyucu unsurları a&ccedil;ılmış olan mallardan; iadesi sağlık
                            ve&nbsp;hijyen&nbsp;a&ccedil;ısından uygun olmayanların teslimine (iv) tesliminden sonra başka
                            &uuml;r&uuml;nlerle karışan ve doğası gereği ayrıştırılması m&uuml;mk&uuml;n olmayan mallara,
                            (v)
                            malın tesliminden sonra ambalaj, bant, m&uuml;h&uuml;r, paket gibi koruyucu unsurları
                            a&ccedil;ılmış
                            olması halinde maddi ortamda sunulan kitap, dijital i&ccedil;erik ve bilgisayar sarf
                            malzemelerine,
                            (vi) abonelik s&ouml;zleşmesi kapsamında sağlananlar dışında, gazete ve dergi gibi s&uuml;reli
                            yayınların teslimine, (vii) belirli bir tarihte veya d&ouml;nemde yapılması gereken, konaklama,
                            eşya
                            taşıma, araba kiralama, yiyecek-i&ccedil;ecek tedariki ve eğlence veya dinlenme amacıyla yapılan
                            boş
                            zamanın değerlendirilmesine, (viii) elektronik ortamda anında ifa edilen hizmetler
                            veya&nbsp;T&uuml;ketici&rsquo;ye&nbsp;anında teslim edilen&nbsp;gayrimaddi&nbsp;mallara, (ix)
                            cayma
                            hakkı s&uuml;resi sona ermeden &ouml;nce,&nbsp;T&uuml;ketici&rsquo;nin&nbsp;onayı ile ifasına
                            başlanan hizmetlere, ve (x) fiyatı finansal piyasalardaki dalgalanmalara bağlı olarak değişen ve
                            Şirketin kontrol&uuml;nde olmayan mal veya hizmetlere ilişkin s&ouml;zleşmelere
                            uygulanmaz.&nbsp;
                        </p>
                    </div>
                    <div>
                        <p> &nbsp;</p>
                    </div>
                    <div>
                        <p>T&uuml;ketici&rsquo;nin&nbsp;cayma hakkını kullanması halinde Şirket, cayma bildiriminin
                            kendisine
                            ulaştığı tarihten itibaren en ge&ccedil; 14 (ond&ouml;rt) g&uuml;n i&ccedil;erisinde almış
                            olduğu
                            toplam bedeli ve&nbsp;T&uuml;ketici&rsquo;yi&nbsp;bor&ccedil; altına sokan kıymetli evrak ve
                            benzeri
                            her t&uuml;rl&uuml; belgeyi&nbsp;T&uuml;ketici&rsquo;ye&nbsp;hi&ccedil;bir masraf
                            y&uuml;klemeksizin
                            iade etmekle y&uuml;k&uuml;ml&uuml;d&uuml;r.&nbsp;</p>
                    </div>
                    <div>
                        <p> Uyuşmazlık Konusunda Başvurulabilecek Yollar &nbsp;</p>
                    </div>
                    <div>
                        <p>İşbu&nbsp;S&ouml;zleşme&rsquo;den&nbsp;doğan her t&uuml;rl&uuml;&nbsp;şikayet, itirazlar ve
                            uyuşmazlıklar, G&uuml;mr&uuml;k ve Ticaret Bakanlığı&rsquo;nca her yıl&nbsp;Aralık&nbsp;ayında
                            belirlenen parasal sınırlara g&ouml;re&nbsp;T&uuml;ketici&rsquo;nin&nbsp;ikametgahının bulunduğu
                            yerdeki yahut S&ouml;zleşme konusu işlemin yapıldığı yerdeki T&uuml;ketici Hakem Heyeti&rsquo;ne
                            veya T&uuml;ketici Mahkemesi&rsquo;ne y&ouml;nlendirilebilir.&nbsp;</p>
                    </div>
                    <div>
                        <p>&nbsp;</p>
                    </div>
                </div>
            </vx-card>

        </div>
        <div><br></div>
    </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import userJson from "../../../public/user.json";
export default {
    data() {
        return {
            logoUrl: "",
        }
    },
    created() {
        this.logoUrl = userJson.userLogo;
    }

}
</script>